import React, { useEffect, useState } from 'react';
import '../../Static/priceinfo.css';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';

const StkManuallyView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    // console.log(formData);

    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>
                <Paper style={{ padding: '2vh' }}>
                    <h3 className='centered-heading'>Manual Stock Item View</h3>
                    <div className="dashed-line"></div>

                    <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                        <tbody>

                            <tr>
                                <td style={{ width: '200px' }}>Item Name</td>
                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                <td style={{ width: '200px', paddingLeft: '2%' }}>Rack</td>
                                <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.rack}</td>
                            </tr>

                            <tr>
                                <td style={{ width: '200px' }}>Location Name</td>
                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.locNm}</td>
                               
                            </tr>

                            <tr>
                                <td style={{ width: '200px' }}>Main Cloth</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.mclothNm}</td>
                                {formData?.m1cltoh !== '' &&
                                    <>
                                        <td style={{ width: '100px', paddingLeft: '2%' }}>M1 Cloth</td>
                                        <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m1clothNm}</td>

                                    </>
                                }
                            </tr>


                            <tr>
                                {formData?.m2cltoh !== '' &&
                                    <>
                                        <td style={{ width: '100px', paddingLeft: '2%' }}>M2 Cloth</td>
                                        <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m2clothNm}</td>

                                    </>
                                }
                                {formData?.m3cltoh !== '' &&
                                    <>
                                        <td style={{ width: '100px', paddingLeft: '2%' }}>M3 Cloth</td>
                                        <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m3clothNm}</td>

                                    </>
                                }
                            </tr>




                        </tbody>

                    </table>

                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                        <Table>
                            <TableHead>
                                <TableRow className='tbl-row'>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SrNo</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Barcode</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Color</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(formData?.tableData) && formData?.tableData.map((item, index) => (
                                    <TableRow key={index}>

                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.barcode}</TableCell>

                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                            {item.size}

                                        </TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                            {item.color}

                                        </TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                            {item.qty}

                                        </TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                            {item.rate}

                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>
        </>
    );
};

export default StkManuallyView;
